import { render, staticRenderFns } from "./MailPage.vue?vue&type=template&id=a9fddbce"
import script from "./MailPage.vue?vue&type=script&lang=js"
export * from "./MailPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports